import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getSeo } from '@/content/seo';

/**
 * Keeps the document head correct across client-side navigation.
 *
 * The prerendered HTML already carries the full head for each route - that is
 * what crawlers and social scrapers read, and it is deliberately static so
 * hydration cannot disturb it. This component only patches the handful of tags
 * that go stale when the router swaps a page without a document load.
 */
export function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getSeo(pathname);

    document.title = seo.title;

    const setMeta = (selector: string, attr: 'content' | 'href', value: string) => {
      document.querySelector(selector)?.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', seo.description);
    setMeta('link[rel="canonical"]', 'href', seo.canonical);
    setMeta('meta[property="og:title"]', 'content', seo.title);
    setMeta('meta[property="og:description"]', 'content', seo.description);
    setMeta('meta[property="og:url"]', 'content', seo.canonical);
    setMeta('meta[name="twitter:title"]', 'content', seo.title);
    setMeta('meta[name="twitter:description"]', 'content', seo.description);
  }, [pathname]);

  return null;
}
